import React, {Component} from 'react';
import {message, Popconfirm, Table} from 'antd';
import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {queryIncuBusinessArchve, queryIncuBusinessOverdue} from '@api/incubator/business';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.contractOverduePage || 1;
    this.getIncuBusinessOverdue();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getIncuBusinessOverdue();
    }
  }

  getIncuBusinessOverdue = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryIncuBusinessOverdue({
      incubatorUuid: this.incuUuid || '',
      start: this.current || 1,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
        });
      }
    });
  };

  incuBusinessArchve = businessUuid => {
    queryIncuBusinessArchve({
      businessUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuBusinessOverdue();
      } else {
        message.error(res.message);
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getIncuBusinessOverdue();
    const { currentShow } = this.props;
    currentShow.contractOverduePage = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/info`}>{record.no}</Link>
        ),
      },
      {
        title: '园区',
        dataIndex: 'incubator',
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
      },
      {
        title: '到期时间',
        dataIndex: 'deadline',
        render: (text, record) =>
          text ? (
            <span>
              {moment.unix(text / 1000).format('YYYY-MM-DD')}
              (逾期{Math.ceil(Math.abs(record.businessInterval) / 1440)}天)
            </span>
          ) : null,
      },
      {
        title: '款项状态',
        dataIndex: 'status',
        render: (text, record) => <span>{text === 0 ? '没有匹配' : '完成匹配'}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => (
          <Popconfirm
            title="确定归档所选合同吗？"
            onConfirm={() => this.incuBusinessArchve(record.uuid)}
          >
            <a>归档合同 </a>
          </Popconfirm>
        ),
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    const { total } = pagination;
    return (
      <div>
        <div className="tips">
          逾期合同(<span className="content">{total}份合同</span>)
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}
export default connect(state => ({ currentShow: state.wb_tab_current }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/contract/TableOverdue.js